import { z } from "zod";

export const GitObjectsQuery = z.object({
  organization: z.string().optional(), // Azure Organization | Bitbucket Workspace slug | Gitlab Group | Github Account (User or Organization)
  project: z.string().optional(), // Only for Bitbucket and Azure
  repository: z.string().optional(), // For all providers. For Gitlab, it's called "project".
  branch: z.string().optional(), // For all providers.
  user: z.string().optional(), // Gitlab user
});

export type GitObjectsQuery = z.infer<typeof GitObjectsQuery>;

export const GitOrganization = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  slug: z.string(),
});

export const GitProject = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  slug: z.string(),
});

export const GitRepository = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  slug: z.string(),

  /**
   * Can be undefined when:
   *  - there are no branches in the repository yet
   *  - Git provider doesn't expose this information on a repository via their API
   */
  defaultBranch: z.string().optional(),
});

export const GitBranch = z.object({
  name: z.string(),
  lastCommitId: z.string(),
});

export type GitOrganization = z.infer<typeof GitOrganization>;
export type GitProject = z.infer<typeof GitProject>;
export type GitRepository = z.infer<typeof GitRepository>;
export type GitBranch = z.infer<typeof GitBranch>;
